



















import { Component } from 'vue-property-decorator'
import { MetaInfo } from 'vue-meta'

// components
import TrainingCard from '@/components/cards/TrainingCard.vue'
// mixins
import NotifyMixin from '@/mixins/NotifyMixin'
// store
import MasterTrainingModule from '@/store/modules/master/training'

@Component({
  components: {
    TrainingCard,
  },
})
export default class Training extends NotifyMixin {
  private get subjects() {
    return MasterTrainingModule.subjects
  }

  private get tgChannels() {
    return MasterTrainingModule.tgChannelsList
  }

  private mounted() {
    if (!this.subjects.length) {
      this.fetchSubjects()
    }

    if (!this.tgChannels.length) {
      this.fetchTgChannels()
    }
  }

  private fetchSubjects() {
    MasterTrainingModule.fetchSubjects()
      .catch(this.notifyError)
  }

  private fetchTgChannels() {
    MasterTrainingModule.fetchTgChannelsList()
      .catch(this.notifyError)
  }

  private metaInfo (): MetaInfo {
    return {
      title: 'Банк заданий',
    }
  }
}
